import { Form, Input, Select } from '@duxton-web/ui';
import React from 'react';

import {
  PUSH_CHANNEL_ACTION_OPTIONS,
  PUSH_CHANNEL_ACTIONS,
  SMART_CAMPAIGN_FORM_KEYS,
} from 'omega-rtc/constants/ucd';
import { useCreateSmartCampaign } from 'omega-rtc/components/container/CreateSmartCampaignProvider';

const SmartCampaignMetaDataAction = ({ watchPushChannelAction }) => {
  const { isPrimaryLanguageContentsEmpty } = useCreateSmartCampaign();
  return (
    <React.Fragment>
      <Form.Item
        label="Action"
        name={SMART_CAMPAIGN_FORM_KEYS.ACTION_TYPE}
        initialValue={PUSH_CHANNEL_ACTIONS.deepLink}
      >
        <Select
          placeholder="Select Action"
          options={PUSH_CHANNEL_ACTION_OPTIONS}
          disabled={isPrimaryLanguageContentsEmpty}
        />
      </Form.Item>
      {watchPushChannelAction !== 'grabApp' && (
        <Form.Item
          label="URL"
          name={SMART_CAMPAIGN_FORM_KEYS.ACTION_URL}
          rules={[{ required: true, message: 'Please enter url' }]}
        >
          <Input
            placeholder="Enter url"
            disabled={isPrimaryLanguageContentsEmpty}
          />
        </Form.Item>
      )}
    </React.Fragment>
  );
};

export default SmartCampaignMetaDataAction;
